export default "__VITE_ASSET__50e69972__"